var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"text-uppercase text-center",attrs:{"title":"Documento de usuario a buscar","id":"qr_validate_papeleria"}},[_c('b-col',[_c('qrcode-reader',{on:{"decode":_vm.onDecode}})],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206da076","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/papeleria/requests/validate.vue
// module id = null
// module chunks = 